import styled from 'styled-components';
import { APIComponentAttributes, APISurveyAttributes } from '@ardoq/api-types';
import { colors } from '@ardoq/design-tokens';
import { EnhancedScopeData } from '@ardoq/data-model';
import { IconName, IconSize } from '@ardoq/icons';
import { SurveyButtons } from '../components/SurveyButtons';
import { FlexBox, Stack } from '@ardoq/layout';
import { Breadcrumbs2 as Breadcrumbs } from '@ardoq/basic-components';
import { NameAndIcon } from '../components/NameAndIcon';
import { scopeDataOperations } from '@ardoq/scope-data';

const BarWrapper = styled(FlexBox).attrs({
  gap: 'medium',
  justify: 'space-between',
  padding: 'large',
  align: 'center',
})`
  background-color: ${colors.surfaceDefault};
  @media (max-width: 700px) {
    flex-wrap: wrap;
  }
`;

type WorkspaceAndComponentHierarchyProps = {
  component: APIComponentAttributes;
  scopeData: EnhancedScopeData;
};

export const WorkspaceAndComponentHierarchy = ({
  scopeData,
  component,
}: WorkspaceAndComponentHierarchyProps) => {
  const breadcrumbs: string[] = [
    scopeData.workspacesById[component.rootWorkspace].name,
    ...scopeDataOperations.getAncestorBreadcrumbs(
      component,
      scopeData.componentsById
    ),
  ];
  return (
    <FlexBox align="center">
      <Breadcrumbs
        breadcrumbs={breadcrumbs}
        leadingIcon={{
          name: IconName.WORKSPACE,
          size: IconSize.MEDIUM,
          rightMargin: 'small',
        }}
        textStyles={{
          fontSize: '14px',
          color: colors.textSubtle,
        }}
      />
    </FlexBox>
  );
};

export const TOPBAR_HEIGHT = '96px';

type TopBarProps = {
  component: APIComponentAttributes;
  scopeData: EnhancedScopeData;
  surveys?: APISurveyAttributes[];
  onSurveyClick?: (survey: APISurveyAttributes) => void;
  submitUpdateLabel?: string;
  changeRequestTooltip?: string;
};

const TopBar = ({
  component,
  scopeData,
  surveys,
  onSurveyClick,
  submitUpdateLabel,
  changeRequestTooltip,
}: TopBarProps) => {
  return (
    <BarWrapper>
      <FlexBox align="center" justify="center" gap="medium">
        <Stack gap="small">
          <WorkspaceAndComponentHierarchy
            component={component}
            scopeData={scopeData}
          />
          <NameAndIcon component={component} scopeData={scopeData} />
        </Stack>
      </FlexBox>
      <SurveyButtons
        component={component}
        surveys={surveys}
        onSurveyClick={onSurveyClick}
        submitUpdateLabel={submitUpdateLabel}
        changeRequestTooltip={changeRequestTooltip}
      />
    </BarWrapper>
  );
};

export { TopBar };
